import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HelpPageComponent} from '../../help-page.component';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-log-in-out',
    templateUrl: './help-page-log-in-out.component.html',
    styleUrls: ['./help-page-log-in-out.component.scss', '../../helpPageModule.scss'],
    standalone: false
})
export class HelpPageLogInOutComponent extends HelpPageComponent implements OnInit
{
    urlLanguage: string;

    constructor(public translate: TranslateService)
    {
        super(translate);
    }

    ngOnInit(): void
    {
        this.urlLanguage = this.translate.currentLang;
    }
    public readonly environment = environment;
}
